import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '@dixa/lib-shared-habla';
import _flatMap from 'lodash/flatMap';
import _groupBy from 'lodash/groupBy';
import _map from 'lodash/map';
import memoize from 'memoize-one';
import moment from 'moment';
import { memo } from 'react';
import { convertToHumanRelativeTime } from '../helpers/timeHelpers';
import { Day } from './types';
const weekdays = moment
    .weekdays()
    .map((weekday) => Day[weekday]);
const getOpeningHoursStr = (intervals) => {
    return (intervals.reduce((_pre, cur) => {
        const open = convertToHumanRelativeTime(cur.open);
        const close = convertToHumanRelativeTime(cur.close);
        return `${open} - ${close}`;
    }, '') || 'Closed');
};
const getGroupedDays = (schedule) => {
    let index = 0;
    let currentKey = '';
    return _groupBy(schedule, (day) => {
        const intervalStr = getOpeningHoursStr(day.intervals);
        const keyStr = `${index}-[${intervalStr}]`;
        if (keyStr !== currentKey) {
            index += 1;
            currentKey = `${index}-[${intervalStr}]`;
        }
        return currentKey;
    });
};
const parseTextFromPayload = memoize((schedule) => {
    const groupedDays = getGroupedDays(schedule);
    const dates = _map(groupedDays, (days, key) => {
        let joinedDayNames = days
            .map((day) => {
            return weekdays[new Date(day.date).getDay()];
        })
            .join(', ');
        if (joinedDayNames ===
            `${Day.Monday}, ${Day.Tuesday}, ${Day.Wednesday}, ${Day.Thursday}, ${Day.Friday}`) {
            joinedDayNames = 'Weekdays';
        }
        if (joinedDayNames === `${Day.Saturday}, ${Day.Sunday}`) {
            joinedDayNames = 'Weekends';
        }
        const openingHours = getOpeningHoursStr(days[0].intervals);
        return (_jsxs("span", { children: [joinedDayNames, ": ", _jsx("strong", { children: openingHours })] }, key));
    });
    const commaSeparatedDates = _flatMap(dates, (date, i) => [date, _jsx("span", { children: ", " }, i)]);
    commaSeparatedDates.pop(); // remove last comma
    return commaSeparatedDates;
});
const OpeningHoursFromPayload = ({ node: { payload: { schedule }, }, }) => {
    return (_jsx("div", Object.assign({ style: { height: '32px' } }, { children: _jsx(Text.Paragraph, Object.assign({ clamp: 2 }, { children: parseTextFromPayload(schedule) })) })));
};
export default memo(OpeningHoursFromPayload);
